export const APP_UPDATE_DATE = "17 October, 2023 | Beta Version 0.5";
